import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';
import { Record } from 'immutable';
import type { RecordOf } from 'immutable';

export const DATASETS_REDUCER_KEY = 'datasetsStore';

export type EntitlementsProps = {
  id?: string;
  expiresAt?: string;
  partnerExpireAt?: string;
  expiresOn?: string;
  checkAlertsUntil?: string;
  active?: boolean;
};

export type DatasetProps = {
  clientId?: string;
  id?: string;
  name?: string;

  platform?: string;
  subscriptionTier?: string;
  createdByClientId?: string;
  createdAt?: string;
  lastSyncedAt?: string;
  lastAccessedAt?: string;
  zipcode?: string;

  shared?: boolean;
  grantorFirstName?: string;
  grantorLastName?: string;
  grantorUsername?: string;
  permissions?: string;
  itemAccessControl?: string;

  disableRemoteAccess?: boolean;
  isDeleted?: boolean;
  ownerId?: string;
  headless?: boolean;

  entitlements?: Array<EntitlementsProps>; // local only data until QCS make it real
};

export type Dataset = RecordOf<DatasetProps>;

export const mkDataset = Record<DatasetProps>({
  clientId: undefined,
  id: undefined,
  name: undefined,

  platform: undefined,
  subscriptionTier: undefined,
  createdByClientId: undefined,
  createdAt: undefined,
  lastSyncedAt: undefined,
  lastAccessedAt: undefined,
  zipcode: undefined,

  shared: undefined,
  grantorFirstName: undefined,
  grantorLastName: undefined,
  grantorUsername: undefined,
  permissions: undefined,
  itemAccessControl: undefined,

  disableRemoteAccess: false,
  isDeleted: false,
  ownerId: undefined,
  headless: false,

  entitlements: undefined,
});

export type DatasetsStore = QcsSyncResourceStore<DatasetProps>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [DATASETS_REDUCER_KEY]: DatasetsStore;
  }
}
